// @ actions
import { setSelectFilter, setCheckFilter, setDateFilter, setApplied } from 'actions/filters'

// @ constants
import { PFM_FILTERS } from 'constants/index';
import { DATE, CUSTOM_ACCOUNTS, ALL_ACCOUNTS, CONTRACT_TYPE } from 'constants/expensesByCategories/filters';

const fallbackFilters = filtersWhenModalOpened => dispatch => {
    dispatch(setDateFilter(
        PFM_FILTERS,
        DATE,
        filtersWhenModalOpened.getIn([DATE, 'active']) || false,
        filtersWhenModalOpened.getIn([DATE, 'selected']) || 'None',
        filtersWhenModalOpened.getIn([DATE, 'from']) || null,
        filtersWhenModalOpened.getIn([DATE, 'to']) || null));
    dispatch(setCheckFilter(
        PFM_FILTERS,
        CUSTOM_ACCOUNTS,
        filtersWhenModalOpened.getIn([CUSTOM_ACCOUNTS, 'active']) || false));
    dispatch(setSelectFilter(
        PFM_FILTERS,
        CONTRACT_TYPE,
        filtersWhenModalOpened.getIn([CONTRACT_TYPE, 'active']) || false,
        filtersWhenModalOpened.getIn([CONTRACT_TYPE, 'selected']) || ALL_ACCOUNTS));
}

const resetFilters = () => dispatch => {
    dispatch(setDateFilter(PFM_FILTERS, DATE, false, 'None', null, null));
    dispatch(setCheckFilter(PFM_FILTERS, CUSTOM_ACCOUNTS, false));
    dispatch(setSelectFilter(PFM_FILTERS, CONTRACT_TYPE, false, ALL_ACCOUNTS));
    dispatch(setApplied(PFM_FILTERS))
}

export default {
    fallbackFilters,
    resetFilters
};